// Copyright © 2025 The Things Industries B.V.

import {
  GET_LABEL_LIST_SUCCESS,
  GET_LABEL_SUCCESS,
  UPDATE_LABEL_SUCCESS,
  DELETE_LABEL_SUCCESS,
  GET_LABEL,
  CREATE_LABEL_SUCCESS,
  GET_LABEL_ENTITIES_SUCCESS,
} from '@console/store/actions/labels.tti'

const label = (state = {}, label) => ({
  ...state,
  ...label,
})

const defaultState = {
  entities: {},
  totalCount: 0,
  selectedLabel: null,
  labelEntities: [],
  labeledTotalCount: 0,
}

const labels = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_LABEL:
      return {
        ...state,
        selectedLabel: payload.id,
      }
    case GET_LABEL_LIST_SUCCESS:
      const labelEntities = payload.entities.reduce(
        (acc, label) => {
          acc[label.ids.label_id] = label
          return acc
        },
        { ...state.entities },
      )

      return {
        ...state,
        entities: labelEntities,
        totalCount: payload.totalCount,
      }
    case GET_LABEL_SUCCESS:
    case CREATE_LABEL_SUCCESS:
    case UPDATE_LABEL_SUCCESS:
      const id = payload.ids.label_id

      return {
        ...state,
        entities: {
          ...state.entities,
          [id]: label(state.entities[id], payload),
        },
      }
    case DELETE_LABEL_SUCCESS:
      const { [payload.id]: deleted, ...rest } = state.entities

      return {
        ...state,
        entities: rest,
      }
    case GET_LABEL_ENTITIES_SUCCESS:
      return {
        ...state,
        labelEntities: payload.entities,
        labeledTotalCount: payload.totalCount,
      }
    default:
      return state
  }
}

export default labels
